<script lang="ts">
  import {
    Root as DrawerRoot,
    Trigger as DrawerTrigger,
    Content as DrawerContent,
    Header as DrawerHeader,
    Title as DrawerTitle,
    Description as DrawerDescription,
  } from "$ui/drawer";
  import { Button } from "$ui/button";

  import Wizard from "$lib/components/onboarding/Wizard.svelte";
  import DataSourcesForm from "$lib/components/integrations/DataSourcesForm.svelte";
  import IntegrateInstallStep from "$lib/components/apps/IntegrateInstallStep.svelte";
  import IntegrateFrontendStep from "$lib/components/apps/IntegrateFrontendStep.svelte";
  import IntegrateBackendStep from "$lib/components/apps/IntegrateBackendStep.svelte";

  export let open: boolean = false;

  let currentStep = 0;
  $: steps = [
    {
      title: "Integrate data sources",
      subtitle: "Choose a product to integrate with by following step-by-step instructions.",
      component: DataSourcesForm,
      props: {
        allowSkipToEnd: true,
      },
    },
    {
      title: "Integrate data sources",
      subtitle: "Choose a product to integrate with by following step-by-step instructions.",
      component: IntegrateFrontendStep,
      props: {
        app_id: undefined,
        hideGenerateKey: true,
        allowSkipToEnd: true,
      },
    },
    {
      title: "Install SDK and initialize client",
      subtitle: "Set up the SDK and connect to our API using your app key.",
      component: IntegrateInstallStep,
      props: {
        app_id: undefined,
        hideGenerateKey: true,
        allowSkipToEnd: true,
      },
    },
    {
      title: "Integrate data sources",
      subtitle: "Choose a product to integrate with by following step-by-step instructions.",
      component: IntegrateBackendStep,
      props: {
        app_id: undefined,
        hideGenerateKey: true,
      },
    },
  ];
</script>

<DrawerRoot bind:open preventScroll={false} closeFocus={null} onOpenChange={() => {}}>
  <DrawerTrigger>
    <Button class="w-full min-h-[46px]">Integration Instructions</Button>
  </DrawerTrigger>
  <DrawerContent>
    <DrawerHeader class="pt-8 px-6 pb-4 relative">
      <DrawerTitle class="text-xl text-left">Integration Instructions</DrawerTitle>
      <DrawerDescription class="p text-base text-left"
        >Follow the instructions to integrate your app with Permissions Assurance</DrawerDescription
      >
    </DrawerHeader>
    <div class="px-6 flex-1 flex flex-col overflow-auto">
      <Wizard {steps} onFinish={() => (open = false)} bind:wizardStep={currentStep} />
    </div>
  </DrawerContent>
</DrawerRoot>
